"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FailedToDecryptDashboardBeforeClient = void 0;
class FailedToDecryptDashboardBeforeClient extends Error {
    constructor() {
        super(`Vizzly offers dashboard encryption to keep your dashboard configurations secure.
Please ensure your Vizzly Query Engine is still setup to manage encrypted dashboards.`);
        this.name = 'FailedToDecryptDashboardBeforeClient';
    }
}
exports.FailedToDecryptDashboardBeforeClient = FailedToDecryptDashboardBeforeClient;
